import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BillingInformation, TaxType } from './billing';
import { Observable } from 'rxjs';

@Injectable()
export class BillingService {
  constructor(private http: HttpClient) {}

  getBillingInformation() {
    return this.http.get('/finance/invoice-data');
  }

  updateBillingInformation(billingInformation: BillingInformation) {
    return this.http.post('/finance/invoice-data', billingInformation);
  }

  getTaxTypes(): Observable<TaxType[]> {
    return this.http.get<TaxType[]>('/finance/invoice-data/tax-types');
  }
}
